<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Detail Student</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <span @click="GoToPageNotification()">
            <!-- <CIcon name="cil-envelope-closed" class="float-right mr-3" /> -->
            <br />
            <img
              src="../assets/img/iconInboxTeacher.png"
              width="40px"
              class="float-right mr-2 mt-2"
            />
          </span>

          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>
    <CCard class="custom-card h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <CRow>
                <h5 class="text-left mt-2 d-flex d-sm-none text-black bold">
                  Detail Student <br />
                </h5>

                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <CCard class="p-2 d-none d-sm-flex">
                    <CCol sm="12" lg="12">
                      <CRow>
                        <CCol sm="12" lg="12" class="float-right">
                          <CRow>
                            <CCol sm="9" lg="9">
                              Class
                              <CBadge color="primary">{{
                                profile.Subject
                              }}</CBadge>
                              <br />
                              <CRow>
                                <CCol sm="3" lg="3">
                                  <strong>Student name </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  : {{ profile.StudentName }}
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Parent name </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  : {{ profile.ParentName }}
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Contact No </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  : {{ profile.ContactNo }}
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Language </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  :
                                  <span
                                    v-for="item in languages"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Language }} ,
                                  </span>
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Session </strong>
                                </CCol>
                                <CCol sm="9" lg="9">
                                  :
                                  <span
                                    v-for="item in sessions"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Session }} ,
                                  </span>
                                </CCol>

                                <CCol sm="3" lg="3"
                                  ><strong> Time </strong>
                                </CCol>
                                <CCol sm="9" lg="9">
                                  :
                                  <span
                                    v-for="item in times"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Time }} ,
                                  </span>
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Class Code </strong></CCol
                                >
                                <CCol sm="9" lg="9"> : </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Package </strong></CCol
                                >

                                <CCol sm="9" lg="9">
                                  <span v-if="profile.isGroup == false">
                                    : One To One</span
                                  >
                                  <span v-else>: Group Of Two</span></CCol
                                >

                                <CCol sm="3" lg="3">
                                  <strong>Start Time </strong></CCol
                                >

                                <CCol sm="9" lg="9">
                                   <b> {{ profile.StartTime }} </b>
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>End Time </strong></CCol
                                >

                                <CCol sm="9" lg="9">
                                  <b> {{ profile.EndTime }} </b>
                                </CCol>
                              </CRow>

                              <br />
                            </CCol>
                            <CCol sm="3" lg="3">
                              <strong class="mt-5">
                                <i>{{ profile.CreatedTime }}</i></strong
                              >
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol sm="12" lg="12">
                            <CButton
                              color="success"
                              class="mt-3 mb-3"
                              size="lg"
                              block
                               @click="InsertAcceptSchedule"
                              >Accept</CButton
                            >

                             <CButton
                              color="danger"
                              class="mt-3 mb-3"
                              size="lg"
                              block
                               @click="rejectModal = true"
                              >Reject</CButton
                            >
                          </CCol>
                  </CCard>

                  <div class="p-2 d-flex d-sm-none">
                    <CCard>
                      <CCol sm="12" lg="12">
                        <CRow>
                          <CCol sm="12" lg="12" class="float-right">
                            <CRow>
                              <CCol sm="9" lg="9" class="mt-2">
                                Class
                                <CBadge color="primary">{{
                                  profile.Subject
                                }}</CBadge>
                                <br />
                                <CRow>
                                  <CCol sm="12" lg="12">
                                    <strong>Student name </strong>
                                    : {{ profile.StudentName }}
                                  </CCol>

                                  <CCol sm="12" lg="12">
                                    <strong>Parent name </strong>
                                    : {{ profile.ParentName }}
                                  </CCol>

                                  <CCol sm="12" lg="12">
                                    <strong>Contact No </strong>
                                    : {{ profile.ContactNo }}
                                  </CCol>

                                  <CCol sm="12" lg="12">
                                    <strong>Language </strong>
                                    :
                                    <span
                                      v-for="item in languages"
                                      v-bind:key="item.Id"
                                    >
                                      {{ item.Language }} ,
                                    </span>
                                  </CCol>

                                  <CCol sm="12" lg="12">
                                    <strong>Session </strong>
                                    :
                                    <span
                                      v-for="item in sessions"
                                      v-bind:key="item.Id"
                                    >
                                      {{ item.Session }} ,
                                    </span>
                                  </CCol>

                                  <CCol sm="12" lg="12"
                                    ><strong> Time </strong>
                                    :
                                    <span
                                      v-for="item in times"
                                      v-bind:key="item.Id"
                                    >
                                      {{ item.Time }} ,
                                    </span>
                                  </CCol>

                                  <CCol sm="12" lg="12">
                                    <strong>Class Code :</strong>
                                  </CCol>

                                  <CCol sm="12" lg="12">
                                    <strong>Package </strong> : One To One</CCol
                                  >

                                  <CCol sm="12" lg="12">
                                    <strong>Start Time </strong> :
                                  <b> {{ profile.StartTime }} </b>
                                  </CCol>

                                  <CCol sm="12" lg="12">
                                    <strong>End Time </strong> :
                                       <b> {{ profile.EndTime }} </b>
                                   </CCol>
                                </CRow>

                                <br />
                              </CCol>
                              <CCol sm="3" lg="3">
                                <strong class="mt-5">
                                  {{ profile.CreatedTime }}</strong
                                >
                              </CCol>
                            </CRow>
                          </CCol>
                          <CCol sm="12" lg="12">
                            <CButton
                              color="success"
                              class="mt-3 mb-3"
                              size="lg"
                              block
                              @click="InsertAcceptSchedule"
                              >Accept</CButton
                            >

                             <CButton
                              color="danger"
                              class="mt-3 mb-3"
                              size="lg"
                              block
                               @click="rejectModal = true"
                              >Reject</CButton
                            >
                          </CCol>
                        </CRow>
                      </CCol>
                    </CCard>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
    <CModal
                title="Reject"
                size="md"
                :show.sync="rejectModal"
                @close="showModal = false"
              >
               
                <label>Please provide your remarks of reject</label>
                <CTextarea
                  placeholder="Content Remark..."
                  vertical
                  rows="5"
                  v-model="Reason"
                  class="m-0"
                />
                <template #footer>
                  <CButton
                    type="submit"
                    color="info"
                    class="p-2"
                    @click="InsertRejectSchedule"
                    >Proceed</CButton
                  >
                </template>
              </CModal>

  </div>
</template>


<script>
import { ThirdPartyDraggable } from "@fullcalendar/interaction";
import backgroundBanner from "../assets/img/bgApps.jpg";

import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/bgLogin.png";
import backgroundUrlTemplate from "../assets/img/bg.png";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      profile: {},
      languages: [],
      sessions: [],
      times: [],
      successModal: false,
      rejectModal: false,

      StartTime: "",
      EndTime: "",
      Reason: "",
    };
  },
  async mounted() {
    await this.GetNotificationTeacher();
    await this.GetConfirmationLanguage();
    await this.GetConfirmationSession();
    await this.GetConfirmationTime();
  },
  methods: {
    InsertAcceptSchedule() {
      const formData = new FormData();

  formData.append("SuggestID", this.profile.SuggestId);
      formData.append("StudentId", this.profile.StudentId);
      formData.append("Reason", "Accept Schedule");
        formData.append("isAccept", true);

      return this.$API
        .post(this.$InsertStudentSchedule, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.GoToPageNotification();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        });
    },
    InsertRejectSchedule() {
      const formData = new FormData();

  formData.append("SuggestID", this.profile.SuggestId);
      formData.append("StudentId", this.profile.StudentId);
      formData.append("Reason", this.Reason);
        formData.append("isAccept", false);

      return this.$API
        .post(this.$InsertStudentSchedule, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.GoToPageNotification();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        });
    },
    async GetNotificationTeacher() {
      this.$API
        .get(
          this.$NotificationTeacherSchedule +
            "?notiId=" +
            this.$route.query.notiId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.profile = response.data;
          }
        });
    },
    async GetConfirmationLanguage() {
      this.$API
        .get(
          this.$NotificationClassLanguage +
            "?notiId=" +
            this.$route.query.notiId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.languages = response.data;
          }
        });
    },

    async GetConfirmationSession() {
      this.$API
        .get(
          this.$NotificationClassSession +
            "?notiId=" +
            this.$route.query.notiId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.sessions = response.data;
          }
        });
    },

    async GetConfirmationTime() {
      this.$API
        .get(
          this.$NotificationClassTime + "?notiId=" + this.$route.query.notiId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.times = response.data;
          }
        });
    },
    GoToPageNotification() {
      this.$router.push("/NotificationTeacher?userId=" + this.profile.ToUserId);
    },
   
  },
};
</script>
